import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EmailData } from "@shared/services/alert-message/alert-message.model";

@Component({
	selector: "app-email-dialog",
	templateUrl: "./email-dialog.component.html",
	styleUrl: "./email-dialog.component.scss",
	standalone: false
})
export class EmailDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<EmailDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: EmailData
	) { }

	/* onNoClick(): void {
		this.dialogRef.close();
	} */

	close() {
		this.dialogRef.close();
	}
}